import React, { useState } from "react"

import {
    initialValues as _initialFileValues
} from "../../../../schema/files/fileSchema"

import {
    useFiles,
    fileModuleTypes,
    fileReferenceTypes,
    targetTypes as fileTargetTypes
} from "../../../../hooks/api/useFiles"

import { useItems, itemTypes, targetTypes, actionTypes } from "../../../../hooks/api/useItems"

import {
    useInjectionFields,
    getUpdateFieldValuesPayload,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

import {
    createProductInjectionFieldsPayload,
} from "../../utils/injectionFields"

import { useProduct, productImageTypes as _productImageTypes } from "./useProduct"

export function useProductImage({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const {
        update: updateItemImage,
        isUploading,
        uploadState
    } = useItems({
        itemType: itemTypes.item,
        targetType: targetTypes.item,
        actionType: actionTypes.item.image
    });

    const { updateLastUpdateProduct } = useProduct({ routeType })

    const {
        create: createFile,
        get: getFile,
        list: listFiles,
        remove: removeFiles,
        filterOperatorTypes
    } = useFiles({ targetType: fileTargetTypes.file });

    const { updateFieldValues } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.item.id
    });

    // list product images
    const listProductImages = async ({
        props,
        productId = 0,
        imageType = '',
        imageTag = '',
        dataTypes = [],
    }) => {

        props.dataTypes = dataTypes
        // props.configuration = configuration.enableServerClientCancellation

        let filterValues = []

        filterValues.push({
            name: "module",
            operator: filterOperatorTypes.eq,
            value: fileModuleTypes.item.product.value,
        })

        filterValues.push({
            name: "file_ref",
            operator: filterOperatorTypes.eq,
            value: fileReferenceTypes.item.product.value,
        })

        filterValues.push({
            name: "type",
            operator: filterOperatorTypes.eq,
            value: imageType,
        })

        filterValues.push({
            name: "tag",
            operator: filterOperatorTypes.eq,
            value: imageTag,
        })

        filterValues.push({
            name: "refer_id",
            operator: filterOperatorTypes.eq,
            value: productId,
        })

        // if (productIds.length > 0) {
        //     filterValues = [...filterValues, ...[
        //         {
        //             name: `id`,
        //             operator: filterOperatorTypes.anyOf,
        //             value: JSON.stringify(productIds),
        //         },
        //     ]]
        // }

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        // const result = await list(props)

        const result = await listFiles(props)

        let data = result?.data?.files ? result.data.files : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    // get product image
    const getProductImage = async ({ id }) => {

        // const result = await listFiles({ id, dataTypesArray })

        const result = await getFile({ id })

        let data = result?.data?.file ? result.data.file : {}

        return data

    }

    // done
    // add product nfc image
    const addProductNfcImage = async ({
        productId: _productId,
        lastUpdateUserId: _lastUpdateUserId,
        lastUpdateUserDisplay: _lastUpdateUserDisplay,
        inputFile: _inputFile,
        imageType: _imageType,
        imageTag: _imageTag,
        nfcIdentityNo: _nfcIdentityNo,
        nfcPersonName: _nfcPersonName,
        nfcDetails: _nfcDetails
    }) => {

        let newFileId = ''

        if (_inputFile?.selectedFile) {

            // have to search the files to removed for previously
            // let existingFiles = await fetchFiles({ referId: id })
            const props = {
                limit: -1,
                offset: 0,
                filterValue: [],
                sortInfo: {
                    id: "id",
                    dir: 0,
                }
            }

            const { data: existingFiles } = await listProductImages({
                props,
                productId: _productId,
                imageType: _productImageTypes.nfcImage.typeValue,
                imageTag: _productImageTypes.nfcImage.tagValue
            })

            // let existingFiles = await listProductImages({ referId: id })

            let deleteFileIds = existingFiles.map(i => i.id)

            if (deleteFileIds.length > 0) {
                // await deleteFiles({ fileIds: deleteFileIds })
                await deleteProductImages({ ids: deleteFileIds })
            }

            let fileName = _inputFile?.source?.fileName
            let base64 = _inputFile?.selectedFile

            let fileExtension = fileName.split('.').pop();
            let newFileName = `${_productId}.${fileExtension}` // use product id as file name

            // base64 = base64.toString().replace('data:image/png;base64,', '')

            base64 = base64.toString().split(',').pop();

            // console.log('base64', base64)

            let dataFile = {
                file: {
                    base64_attachments: [
                        {
                            ..._initialFileValues,
                            module: fileModuleTypes.item.product.value, /* required */
                            file_ref: fileReferenceTypes.item.product.value, /* required */
                            type: _imageType, /* required */
                            tag: _imageTag,
                            name: `${newFileName}`, /* required */
                            description: `Identity No. : ${_nfcIdentityNo} / Name : ${_nfcPersonName}`,
                            refer_id: _productId, /* required */
                            base64_code: base64
                        }
                    ]
                }
            }

            let response = await createFile({ data: dataFile })

            // get the file id
            newFileId = response?.data?.upload_results[0]?.file.id

            // setSystemLoading(false)

        }

        let targetInjectionPropIds = [
            `nfcPersonName`,
            `nfcIdentityNo`,
            `nfcDetails`
        ]

        let nfcInfo = {
            nfcPersonName: _nfcPersonName,
            nfcIdentityNo: _nfcIdentityNo,
            nfcDetails: _nfcDetails
        }

        // if the file id uploaded only override this injection props
        if (newFileId !== '') {
            targetInjectionPropIds = [
                ...targetInjectionPropIds,
                `nfcFileId`,
            ]
            nfcInfo = {
                ...nfcInfo,
                nfcFileId: newFileId,
            }
        }

        // append inj fields - for existing product only for nfc details
        let injectionFieldsLoaded = createProductInjectionFieldsPayload({
            productId: _productId,
            barcode: ``,
            data: {},
            mainData: {},
            targetInjectionFieldIds: targetInjectionPropIds,
            nfcInfo
        })

        // injection fields
        const response = await updateFieldValues({ data: getUpdateFieldValuesPayload({ items: injectionFieldsLoaded }), overrideScopeType: injectionFieldScopeTypes.item.id })


        let _p = {
            productId: _productId,
            lastUpdateUserId: _lastUpdateUserId,
            lastUpdateUserDisplay: _lastUpdateUserDisplay
        }

        await updateLastUpdateProduct(_p)

        return response

    }

    // add product images
    const addProductImages = async ({
        productId: _productId,
        lastUpdateUserId: _lastUpdateUserId,
        lastUpdateUserDisplay: _lastUpdateUserDisplay,
        inputFiles: _inputFiles,
        imageType: _imageType,
        imageTag: _imageTag
    }) => {

        let dataFiles = []

        _inputFiles.forEach((i, index) => {

            let fileName = i?.source?.fileName
            let base64 = i?.base64

            let fileExtension = fileName.split('.').pop();
            let newFileName = `${_productId}.${fileExtension}` // use product id as file name

            // base64 = base64.toString().replace('data:image/png;base64,', '')

            base64 = base64.toString().split(',').pop();

            // console.log('base64', base64)

            dataFiles.push({
                ..._initialFileValues,
                module: fileModuleTypes.item.product.value, /* required */
                file_ref: fileReferenceTypes.item.product.value, /* required */
                type: _imageType, /* required */
                tag: _imageTag,
                name: `${newFileName}`, /* required */
                description: `Gallery Image #${(index + 1)}`,
                refer_id: _productId, /* required */
                base64_code: base64
            })

        })

        let dataFile = {
            file: {
                base64_attachments: dataFiles
            }
        }

        let response = await createFile({ data: dataFile })


        let _p = {
            productId: _productId,
            lastUpdateUserId: _lastUpdateUserId,
            lastUpdateUserDisplay: _lastUpdateUserDisplay
        }

        await updateLastUpdateProduct(_p)

        return response

    }

    // update the product image
    const updateProductImage = async ({
        productId: _productId,
        lastUpdateUserId: _lastUpdateUserId,
        lastUpdateUserDisplay: _lastUpdateUserDisplay,
        imageId: _imageId,
        description: _description
    }) => {

        const data = {
            file: {
                description: _description
            }
        }

        const response = await updateItemImage({
            id: _imageId,
            data
        });

        // let response1 = await update({
        //     id: _itemId,
        //     data: data1,
        //     targetType: itemTargetTypes.item,
        //     skipSchedulerRequestSubmit: true
        // })

        let _p = {
            productId: _productId,
            lastUpdateUserId: _lastUpdateUserId,
            lastUpdateUserDisplay: _lastUpdateUserDisplay
        }

        await updateLastUpdateProduct(_p)

        return response

    }

    // remove product images
    const deleteProductImages = async ({
        productId: _productId,
        lastUpdateUserId: _lastUpdateUserId,
        lastUpdateUserDisplay: _lastUpdateUserDisplay,
        ids: _ids = []
    }) => {

        let response = await removeFiles({ ids: _ids, actionType: actionTypes.item.image })

        let _p = {
            productId: _productId,
            lastUpdateUserId: _lastUpdateUserId,
            lastUpdateUserDisplay: _lastUpdateUserDisplay
        }

        await updateLastUpdateProduct(_p)

        return response
    }

    return {
        filterOperatorTypes,
        isUploading,
        uploadState,
        listProductImages,
        getProductImage,
        addProductNfcImage,
        addProductImages,
        updateProductImage,
        deleteProductImages
    }
}